module.exports = __webpack_public_path__ + "static/lightning-datepicker-readonly-3898249640312461686f209887c99b95.png";